import {ReadUser, UpdateNotificationsPreferences} from '@tinct/core-api-models';
import {Button, Card, CardContent, CardFooter, CardHeader, CardTitle,} from '@tinct/web-components';
import {FormProvider} from 'react-hook-form';
import {useUpdateNotificationsPreferencesForm} from '../hooks/use-update-notifications-preferences-form';
import {createConnectedInputHelpers} from '@tinct/web-form';

type UpdateNotificationsPreferencesSectionProps = {
  user: ReadUser;
};

const NOTIFICATION_OPTIONS = [
  {key: 'notificationsPreferences.channels.products' as const, label: 'Product updates'},
  {key: 'notificationsPreferences.channels.news' as const, label: 'News and announcements'},
];

export const UpdateNotificationsPreferencesSection = ({
  user,
}: UpdateNotificationsPreferencesSectionProps) => {
  const {form, handleSubmit} = useUpdateNotificationsPreferencesForm(user);

  const { ControlledSwitchInput } = createConnectedInputHelpers<UpdateNotificationsPreferences>()

  return (
    <FormProvider {...form}>
      <form
        id="update-notifications-preferences-form"
        onSubmit={handleSubmit}
      >
        <Card className="rounded-2xl">
          <CardHeader>
            <CardTitle className="text-xl">Notifications</CardTitle>
          </CardHeader>
          <CardContent className="pt-2">

            <div className="flex flex-wrap gap-6 py-6">
              {NOTIFICATION_OPTIONS.map((option) => (
                <ControlledSwitchInput
                  key={option.key}
                  name={option.key}
                  label={option.label}
                  inline
                />
              ))}
            </div>

          </CardContent>
          <CardFooter className="justify-end border-t">
            <Button type="submit" form="update-notifications-preferences-form">
              Save
            </Button>
          </CardFooter>
        </Card>
      </form>
    </FormProvider>
  );
};
